/** Corta um texto em no máximo `max` palavras, adicionando reticências. */
export function truncateWords(text: string | null | undefined, max = 15): string {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  if (words.length <= max) return words.join(" ");
  return words.slice(0, max).join(" ").replace(/[.,;:!?—-]+$/, "") + "…";
}
